export var SubtitleVariants;
(function (SubtitleVariants) {
    SubtitleVariants["default"] = "default";
})(SubtitleVariants || (SubtitleVariants = {}));
//# sourceMappingURL=constants.js.map